export * from './patient-opened-halted-encounters.service';